/* eslint-disable no-unused-expressions */
import * as events from '../utils/constants/formEvents';
import { createCookie, getCookie, cookies } from '../utils/common/cookies';
import { getClaimLossCause } from '../utils/constants/typeClaimMapping';

export function sendEventData(formData, event) {
  const data = {};

  const googlePID = window.dataLayer?.find((d) => d.PID)?.PID;
  googlePID && (data.PID = googlePID);

  const supportId = getCookie(cookies.fullStorySupportId);
  supportId && (data.fullstory_support_id = supportId);

  const claimSupportId = setOrGetSupportId();
  claimSupportId && (data.claim_support_id = claimSupportId);

  const policy = JSON.parse(window.sessionStorage.getItem('thePolicy'));
  policy?.policyNumber && (data.policy_number = policy.policyNumber);
  policy?.policyProvince && (data.province = policy.policyProvince);

  const typeOfClaim = formData?.claim_type?.claim_type;
  typeOfClaim && (data.claim_type = typeOfClaim);

  let nested;
  if (typeOfClaim === 'Vehicle' && formData.claim_type.vehicle?.policySystemId === 'injuryOnly') {
    nested = { ...formData.abonly?.data };
  } else if (typeOfClaim === 'Vehicle') {
    nested = { ...formData.auto?.data };
  } else if (typeOfClaim === 'Home') {
    nested = { ...formData.property?.data };
  }

  if (nested && Object.keys(nested).length) {
    const lossCause = nested.lossCause?.value;
    lossCause && (data.loss_cause = getClaimLossCause[lossCause]);
  }

  switch (event) {
    case events.FORM_EVENT_SAVECONTINUELATER:
      window.FS.event('Save and Continue Later', data);
      break;
    case events.FORM_EVENT_SUBMITTED:
      window.FS.event('Submit Claim', data);
      break;
    case events.FORM_EVENT_LEAVINGPAGE:
      window.FS.event('Leaving Page', data);
      break;
    default:
      window.FS.event(event, data);
      break;
  }
}

export function setUserData(sonnetAddressBookUid) {
  const supportId = setOrGetSupportId();
  window.FS.identify(sonnetAddressBookUid);
  return supportId;
}

export function setOrGetSupportId() {
  const storedSupportId = getCookie(cookies.claimSupportId);
  let supportId = storedSupportId;
  if (!storedSupportId) {
    supportId = generateSupportID(generatrBTT());
    createCookie(cookies.claimSupportId, supportId, false, true);
  }
  return supportId;
}

export function getSupportId() {
  const supportId = getCookie(cookies.claimSupportId);
  return supportId;
}

/**
 * Aux functions
 */
function generatrBTT() {
  const btt = new Date();
  window.sessionStorage.setItem('date', btt.toJSON());
  return btt.getTime().toString();
}

function generateSupportID(browserTabToken) {
  const last12chars = browserTabToken.substring(browserTabToken.length - 12);
  return `${last12chars.substring(0, 4)}-${last12chars.substring(4, 8)}-${last12chars.substring(8)}`;
}
